module.exports = "<div style=\"text-align: center;\" class=\"ot-search-description\">\n  {{\"LANDING.SUMMARY\" | translate | sprintf:params.count}}\n  <span uib-dropdown class=\"ot-event-action-menu\">\n    <span class=\"ot-current-city\" uib-dropdown-toggle>{{params.city}}</span>\n    <ul class=\"uib-dropdown-menu ot-dropdown-menu\" uib-dropdown-menu aria-labelledby=\"simple-dropdown\">\n      <li ng-repeat=\"city in params.cities\">\n        <a ng-href=\"{{vm.getUrl(city)}}\" ng-click=\"goTo(city)\">{{city.label | translate}}</a>\n      </li>\n    </ul>\n  </span>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/directives/content/searchDescription.html
 ** module id = 275
 ** module chunks = 1
 **/